<template>
  <play-list />
</template>
<script>
import PlayList from '../components/client-lms/PlayList.vue';

export default {
  name: 'PlaylistsPage',

  components: {
    PlayList,
  },
};
</script>
